export default __webpack_public_path__ + "static/media/YouthImage9.4aad1472.png";